import { reactToCwp } from '../../../../common/react-utils'
import { AdjustedRevenuesTables } from './AdjustedRevenuesTables'

export default reactToCwp(AdjustedRevenuesTables)
